module.exports = __webpack_public_path__ + "static/Ringing-b0320431a752d83d4b82635ce07b5104.jpg";